import { NavLink, Outlet } from 'react-router-dom'
import { Tags, Tag, Coins, Users, UserCircle, ShieldCheck } from 'lucide-react'
import { PageHeader } from '@/components/ui/page-header'
import { cn } from '@/lib/utils'
import { useHousehold } from '@/context/HouseholdContext'
import { useT } from '@/i18n/I18nProvider'

const SUB = [
  { to: 'casa', labelKey: 'settings.profile', icon: UserCircle },
  { to: 'categorias', labelKey: 'settings.categories', icon: Tags },
  { to: 'tags', labelKey: 'settings.tags', icon: Tag },
  { to: 'moeda', labelKey: 'settings.currency', icon: Coins },
  { to: 'usuarios', labelKey: 'settings.users', icon: Users },
]

export function SettingsPage() {
  const { t } = useT()
  const { isSuperAdmin } = useHousehold()
  // Menu "Adm. usuários" (gestão cross-tenant da plataforma) só para o super-admin.
  const sub = isSuperAdmin
    ? [...SUB, { to: 'plataforma', labelKey: 'settings.platformUsers', icon: ShieldCheck }]
    : SUB
  return (
    <div className="mx-auto max-w-5xl space-y-6">
      <PageHeader title={t('settings.title')} />

      {/* Sub-menu */}
      <nav className="flex gap-1 border-b">
        {sub.map((s) => (
          <NavLink
            key={s.to}
            to={s.to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2 border-b-2 px-3 py-2 text-sm transition-colors',
                isActive
                  ? 'border-primary text-foreground font-medium'
                  : 'text-muted-foreground hover:text-foreground border-transparent',
              )
            }
          >
            <s.icon className="size-4" />
            {t(s.labelKey)}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  )
}
